import { create } from "zustand";
import type { PrejoinCaseInfo } from "../pages/protected/public-meeting/Prejoin.Meeting";

interface MeetingStore {
  /* ---------------- UI State ---------------- */

  caseItem: any;
  setCaseItem: (v: any) => void;
  meetingState: any;
  setMeetingState: (v: any) => void;
  todaysSchedule: PrejoinCaseInfo[];
  setTodaysSchedule: (v: PrejoinCaseInfo[]) => void;
}

/* ---------------- Store ---------------- */

export const usePublicMeetingStore = create<MeetingStore>((set) => ({
  caseItem: null,
  setCaseItem: (data) => set({ caseItem: data }),
  meetingState: "prejoin",
  setMeetingState: (data) => set({ meetingState: data }),
  todaysSchedule: [],
  setTodaysSchedule: (data) => set({ todaysSchedule: data }),
}));
